import { styled } from "@mui/material";
import { FOOTER_HEIGHT } from "../../utils/constants";
import ContentWrapper from "../ContentWrapper";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../config";
import { sizing } from "../../utils/methods";
import { Facebook, Instagram, LinkedIn, Telegram } from "@mui/icons-material";
import { Text } from "../Typography";
// import { useContext } from "react";
// import { AppContext } from "../../contexts";
import { AppTitle } from "../Header/AppTitle";
import { BOTTOM_NAV_CLEARANCE } from "../BottomNavBar";
import useAuthorization from "../../contexts/useAuthorization";

interface FooterProps {
  removeMaxWidth?: boolean;
}

const FooterComponent = ({ removeMaxWidth }: FooterProps) => {
  // const { currentTheme, toggleThemeMode } = useContext(AppContext);

  const { loggedIn } = useAuthorization();
  return (
    <Footer>
      <ContentWrapper sx={{ border: 0, maxWidth: removeMaxWidth ? "100%" : "1560px", backgroundColor: "transparent" }}>
        <FooterWrapper
          sx={{
            borderRadius: "20px 20px 0px 0px",
            backgroundColor: "back.darkGreen",
            maxWidth: removeMaxWidth ? "100%" : "1560px",
          }}
        >
          <Box sx={{ padding: sizing(6), paddingX: { xs: "18px", md: sizing(6).md } }}>
            <Text sx={{ color: "common.white", paddingBottom: 6 }} bold>
              Community
            </Text>
            <List sx={{ flexDirection: "row", gap: "12px", flexWrap: "wrap" }}>
              {/* <Tooltip
                arrow={true}
                TransitionComponent={Zoom}
                title={`Toggle ${currentTheme === "dark" ? "light" : "dark"} mode`}
                disableInteractive
              >
                <IconButton
                  size="small"
                  sx={{
                    height: "max-content",
                    p: 0,
                    color: "common.white",
                  }}
                  onClick={toggleThemeMode}
                >
                  {currentTheme === "light" ? <DarkModeRounded /> : <LightModeRounded />}
                </IconButton>
              </Tooltip> */}
              <ListItem to={AppRoutes.About.path}>
                <Facebook />
              </ListItem>
              <ListItem to={AppRoutes.About.path}>
                <Instagram />
              </ListItem>
              <ListItem to={AppRoutes.About.path}>
                <LinkedIn />
              </ListItem>
              <ListItem to={AppRoutes.About.path}>
                <Telegram />
              </ListItem>
            </List>
          </Box>
          <Box sx={{ padding: sizing(6), paddingX: { xs: "18px", md: sizing(6).md } }}>
            <List>
              <ListItem to={AppRoutes.EcoBank.path}>Home</ListItem>
              <ListItem to={AppRoutes.Explore.path}>Explore</ListItem>
              {/* <ListItem to={AppRoutes.EcoBank.path}>Terminal</ListItem> */}
              <ListItem to={AppRoutes.About.path}>Help</ListItem>
              {!loggedIn && <ListItem to={`${AppRoutes.Home.path}#login`}>Connect</ListItem>}
              {/* <ListItem to={AppRoutes.About.path}>Become a partner</ListItem> */}
              {/* {!invited && user?.emailVerified && !isGuardian && !isAdmin && !isTrust &&
                <ListItem to={AppRoutes.BecomeGuardian.path}>Become an EcoFutures Guardian</ListItem>
              } */}
              {/* {!invited && user?.emailVerified && !isGuardian && !isAdmin && !isTrust &&
                <ListItem to={AppRoutes.BecomeTrust.path}>Become an EcoFutures Trustee</ListItem>
              } */}
            </List>
          </Box>
          <Box sx={{ padding: sizing(6), paddingX: { xs: "18px", md: sizing(6).md } }}>
            <List>
              <ListItem to={AppRoutes.Glossary.path}>Glossary</ListItem>
              <ListItem to={AppRoutes.About.path}>Privacy policy</ListItem>
              <ListItem to={AppRoutes.About.path}>Terms and conditions</ListItem>
            </List>
          </Box>
        </FooterWrapper>
        <BottomFooterWrapper
          sx={(theme) => ({
            padding: sizing(6),
            paddingX: { xs: "18px", md: sizing(6).md },
            borderRadius: "0px 0px 20px 20px",
            // Below md the floating bottom nav covers the page's last BOTTOM_NAV_CLEARANCE. Reserve it
            // here, inside the black block, so the page ends in the footer and the bar floats over
            // it rather than over an empty strip of page background. The block now runs to the
            // screen edge, so it drops its bottom rounding.
            [theme.breakpoints.down("md")]: {
              paddingBottom: `calc(${theme.spacing(6)} + ${BOTTOM_NAV_CLEARANCE})`,
              borderRadius: 0,
            },
          })}
        >
          <Text medium sx={{ color: "white", display: "flex", gap: "6px", alignItems: "baseline" }}>
            {`Ⓒ`} <AppTitle white /> {`(${new Date().getFullYear()}) All rights reserved.`}
          </Text>
          <Text medium sx={{ color: "white" }}>
            {new Date().toLocaleDateString()}
          </Text>
        </BottomFooterWrapper>
      </ContentWrapper>
    </Footer>
  );
};

const List = styled("div")`
  display: flex;
  flex-direction: column;
`;

const ListItem = styled(Link)`
  cursor: pointer;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.common.white};
  margin-bottom: 5px;
  width: max-content;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.palette.action.hoverFooter};
  }
`;

const Footer = styled("div")(
  () => `
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: ${FOOTER_HEIGHT}px;
`
);

const FooterWrapper = styled("div")`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  justify-content: space-between;
  // border: var(--border);
  // border-color: #3d3d3d;
  border-bottom: none;
  min-height: 50px;

  max-width: 1560px;
  margin: 0 auto;
  @media (max-width: 992px) {
    //justify-content: space-between;
    display: flex;
    flex-direction: column;
  }
`;

const BottomFooterWrapper = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000;
  gap: 6px;
  @media (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
  }

  min-height: 50px;
`;

const Box = styled("div")`
  @media (max-width: 992px) {
    &:not(:last-child) {
      border-bottom: 1px solid #fff;
    }
  }
  flex: 1;
  padding: 24px;
  height: 100%;
  width: 100%;
`;

export default FooterComponent;
